/* =============================================
   LUARARTS — Product Page JS (product.js)
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {

  // Reduce easy video downloading from the browser UI and block right-click menu.
  function protectVideos(scope = document) {
    scope.querySelectorAll('video').forEach((video) => {
      video.setAttribute('controlsList', 'nodownload noplaybackrate');
      video.setAttribute('disablePictureInPicture', '');
      video.addEventListener('contextmenu', (event) => event.preventDefault());
    });
  }

  protectVideos();


  // Product media navigation
  const stack = document.getElementById('lp-media-stack');
  const frames = stack ? Array.from(stack.querySelectorAll('.lp-media-frame')) : [];

  function isMobileGallery() {
    return window.matchMedia('(max-width: 900px)').matches;
  }

  function setMobileActive(index) {
    if (!frames.length) return;
    const safeIndex = ((index % frames.length) + frames.length) % frames.length;
    frames.forEach((frame, i) => {
      const active = i === safeIndex;
      frame.classList.toggle('is-active', active);

      frame.querySelectorAll('video').forEach((video) => {
        if (!isMobileGallery()) return;

        video.muted = true;
        video.autoplay = true;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('playsinline', '');

        // Mobile layout shows the first two media blocks stacked.
        // Keep both videos playing automatically instead of pausing the second one.
        if (i < 2) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    });
    if (stack) stack.dataset.activeIndex = String(safeIndex);
  }

  function autoplayVisibleMobileVideos() {
    if (!isMobileGallery()) return;
    frames.slice(0, 2).forEach((frame) => {
      frame.querySelectorAll('video').forEach((video) => {
        video.muted = true;
        video.autoplay = true;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('playsinline', '');
        video.play().catch(() => {});
      });
    });
  }

  function resetDesktopMedia() {
    frames.forEach((frame) => frame.classList.add('is-active'));
  }

  if (frames.length) {
    if (isMobileGallery()) { setMobileActive(0); autoplayVisibleMobileVideos(); }
    else resetDesktopMedia();
  }

  window.addEventListener('resize', () => {
    if (isMobileGallery()) { setMobileActive(Number(stack?.dataset.activeIndex || 0)); autoplayVisibleMobileVideos(); }
    else resetDesktopMedia();
  });

  document.addEventListener('click', (event) => {
    const nextButton = event.target.closest('.lp-media-next');
    if (!nextButton || !stack || frames.length < 2) return;

    event.preventDefault();
    event.stopPropagation();

    if (isMobileGallery()) {
      const current = Number(stack.dataset.activeIndex || 0);
      setMobileActive(current + 1);
      return;
    }

    const currentScrollIndex = Math.max(0, frames.findIndex((frame) => frame.getBoundingClientRect().top > 80));
    const target = frames[Math.min(frames.length - 1, currentScrollIndex + 1)] || frames[2] || frames[0];
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  // ── FAQ accordion ──
  document.querySelectorAll('.lp-faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.lp-faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.lp-faq-item.open').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // ── Add to Cart (AJAX) - hero form ──
  const cartForm = document.getElementById('lp-cart-form');
  if (cartForm) {
    cartForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = document.getElementById('lp-add-btn');
      const variantId = cartForm.querySelector('[name="id"]').value;
      const originalText = btn.textContent;

      btn.classList.remove('is-added');
      btn.textContent = 'Adding...';
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (res.ok) {
          btn.textContent = '✓ Added';
          btn.classList.add('is-added');
          
          await updateCartCount();
          window.LuarArtsCart?.showOpenCartNotice?.();
          setTimeout(() => {
            btn.textContent = originalText;
            
            btn.classList.remove('is-added');
            btn.disabled = false;
          }, 2500);
        } else {
          throw new Error('Add failed');
        }
      } catch {
        btn.textContent = 'Error';
        btn.disabled = false;
        setTimeout(() => { btn.textContent = originalText; }, 2000);
      }
    });
  }



  // ── Product variant selector ──
  const variantSelect = document.getElementById('lp-variant-select');
  const variantInput = cartForm ? cartForm.querySelector('input[name="id"]') : null;
  const addButton = document.getElementById('lp-add-btn');

  function lpFormatMoney(cents) {
    const moneyFormatEl = document.getElementById('lp-shop-money-format');
    let moneyFormat = '{{amount}}';
    try { moneyFormat = JSON.parse(moneyFormatEl?.textContent || '"{{amount}}"'); } catch {}

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(Number(cents), moneyFormat);
    }

    const value = (Number(cents || 0) / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','));
  }

  function updateSelectedVariant() {
    if (!variantSelect || !variantInput || !addButton) return;
    const option = variantSelect.options[variantSelect.selectedIndex];
    const variantId = option.value;
    const price = option.dataset.price;
    const available = option.dataset.available === 'true';

    variantInput.value = variantId;
    addButton.disabled = !available;
    addButton.innerHTML = available
      ? `Add to cart — <span class="lp-add-price">${lpFormatMoney(price)}</span>`
      : 'Sold out';
  }

  if (variantSelect) {
    variantSelect.addEventListener('change', updateSelectedVariant);
    updateSelectedVariant();
  }

  // ── Related products Add to Cart ──
  document.querySelectorAll('.lp-related-btn[data-variant-id]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const variantId = btn.dataset.variantId;
      btn.classList.remove('is-added', 'is-loading');
      void btn.offsetWidth;
      btn.classList.add('is-loading');
      btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (res.ok) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          await updateCartCount();
          window.LuarArtsCart?.showOpenCartNotice?.();
          setTimeout(() => { btn.classList.remove('is-added'); btn.disabled = false; }, 1200);
        } else {
          throw new Error('Add failed');
        }
      } catch {
        btn.classList.remove('is-loading', 'is-added');
        btn.disabled = false;
      }
    });
  });

  // ── Sticky bar ──
  const heroBtn = document.getElementById('lp-add-btn');
  const stickyBar = document.getElementById('lp-sticky');

  if (heroBtn && stickyBar) {
    const stickyObs = new IntersectionObserver(([entry]) => {
      stickyBar.classList.toggle('visible', !entry.isIntersecting);
    }, { threshold: 0, rootMargin: '-80px 0px 0px 0px' });
    stickyObs.observe(heroBtn);

    // Sticky bar add to cart
    const stickyBtn = stickyBar.querySelector('.lp-sticky-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        if (cartForm) cartForm.dispatchEvent(new Event('submit'));
      });
    }
  }

  // ── Cart count helper ──
  async function updateCartCount() {
    try {
      if (window.LuarArtsCart?.updateCount) {
        await window.LuarArtsCart.updateCount();
        return;
      }
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      document.querySelectorAll('.la-cart-count, .la-floating-cart-count').forEach(el => {
        el.textContent = cart.item_count || 0;
        el.style.display = '';
      });
    } catch {}
  }


  // ── Next media arrow ──
  function ensureProductMediaNextButton() {
    const mainMedia = document.getElementById('lp-media-main');
    const thumbs = Array.from(document.querySelectorAll('.lp-thumb'));
    if (!mainMedia || thumbs.length < 2) return;

    if (!mainMedia.querySelector('#lp-media-next')) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'lp-media-next';
      button.id = 'lp-media-next';
      button.setAttribute('aria-label', 'Next media');
      button.textContent = '›';
      mainMedia.appendChild(button);
    }
  }

  document.addEventListener('click', (event) => {
    const nextButton = event.target.closest('#lp-media-next');
    if (!nextButton) return;

    event.preventDefault();
    event.stopPropagation();

    const thumbs = Array.from(document.querySelectorAll('.lp-thumb'));
    if (thumbs.length < 2) return;

    const activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('active')));
    const nextThumb = thumbs[(activeIndex + 1) % thumbs.length];
    if (nextThumb) nextThumb.click();
    setTimeout(ensureProductMediaNextButton, 0);
  });

  document.querySelectorAll('.lp-thumb').forEach((thumb) => {
    thumb.addEventListener('click', () => setTimeout(ensureProductMediaNextButton, 0));
  });

  ensureProductMediaNextButton();
  autoplayVisibleMobileVideos();
  window.addEventListener('load', autoplayVisibleMobileVideos);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) autoplayVisibleMobileVideos(); });


  // ── Sandboxed live widget preview for product media #2 ──
  function initWidgetPreviews() {
    document.querySelectorAll('[data-widget-preview="1"]').forEach((preview) => {
      if (preview.dataset.loaded === 'true') return;
      const stage = preview.querySelector('.lp-widget-preview-stage');
      if (!stage) return;

      const baseUrl = (preview.dataset.widgetUrl || '').trim();
      if (!baseUrl) {
        stage.innerHTML = '<div class="lp-widget-preview-loader">Preview URL is missing.</div>';
        return;
      }

      const sessionId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      let demoUrl;
      try {
        demoUrl = new URL(baseUrl);
        demoUrl.searchParams.set('preview_session', sessionId);
        demoUrl.searchParams.set('shopify_demo', '1');
      } catch {
        stage.innerHTML = '<div class="lp-widget-preview-loader">Preview URL is invalid.</div>';
        return;
      }

      const iframe = document.createElement('iframe');
      iframe.title = 'Live widget preview';
      iframe.loading = 'lazy';
      iframe.referrerPolicy = 'no-referrer';
      iframe.allow = 'autoplay; fullscreen; clipboard-write';
      // No visual overlay is placed above the iframe, so the widget's own settings icon remains clickable.
      iframe.src = demoUrl.toString();

      // Browser sources are normally designed for a 1920x1080 OBS canvas.
      // Shopify media containers are responsive, so we render the iframe at
      // the original browser-source canvas size and scale it down instead of
      // letting the iframe viewport resize. This keeps all text positions aligned.
      const sourceWidth = 1920;
      const sourceHeight = 1080;
      iframe.style.setProperty('width', `${sourceWidth}px`, 'important');
      iframe.style.setProperty('height', `${sourceHeight}px`, 'important');

      const fitIframe = () => {
        const rect = stage.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        const scale = Math.min(rect.width / sourceWidth, rect.height / sourceHeight);
        const left = (rect.width - sourceWidth * scale) / 2;
        const top = (rect.height - sourceHeight * scale) / 2;
        iframe.style.transform = `translate(${left}px, ${top}px) scale(${scale})`;
      };

      iframe.addEventListener('load', () => {
        const loader = stage.querySelector('.lp-widget-preview-loader');
        if (loader) loader.remove();
        fitIframe();
      });

      stage.appendChild(iframe);
      fitIframe();
      window.addEventListener('resize', fitIframe, { passive: true });
      preview.dataset.loaded = 'true';
    });
  }

  initWidgetPreviews();
  window.addEventListener('pageshow', (event) => {
    // If the browser restores from bfcache, force a fresh demo instance.
    if (!event.persisted) return;
    document.querySelectorAll('[data-widget-preview="1"]').forEach((preview) => {
      const stage = preview.querySelector('.lp-widget-preview-stage');
      if (!stage) return;
      stage.innerHTML = '<div class="lp-widget-preview-loader">Loading interactive preview...</div>';
      preview.dataset.loaded = 'false';
    });
    initWidgetPreviews();
  });

});

// Clean hidden preview URL marker from Shopify product descriptions.
// Use at the very bottom of the product description:
// preview:
// https://elements.meldstudio.co/.../death-count.html
(function () {
  function cleanPreviewMarkers() {
    document.querySelectorAll('[data-preview-clean]').forEach(function (box) {
      var nodes = Array.prototype.slice.call(box.children);
      nodes.forEach(function (el) {
        var text = (el.textContent || '').trim().toLowerCase();
        if (text === 'preview:' || text === 'preview' || text.indexOf('preview:https://') === 0 || text.indexOf('preview: https://') === 0) {
          el.setAttribute('hidden', 'hidden');
          var next = el.nextElementSibling;
          if (next && /^https?:\/\//i.test((next.textContent || '').trim())) {
            next.setAttribute('hidden', 'hidden');
          }
        }
      });

      // Fallback for rich-text editors that keep preview + URL inside the same paragraph with <br>.
      Array.prototype.slice.call(box.querySelectorAll('p, div')).forEach(function (el) {
        var text = (el.textContent || '').trim().toLowerCase();
        if (text.indexOf('preview:') === 0 && text.indexOf('http') !== -1) {
          el.setAttribute('hidden', 'hidden');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanPreviewMarkers);
  } else {
    cleanPreviewMarkers();
  }
})();

// Preview marker cleanup v3: hide Shopify description rows that contain the hidden preview URL.
(function () {
  function cleanPreviewMarkersV3() {
    document.querySelectorAll('[data-preview-clean]').forEach(function (box) {
      var blocks = Array.prototype.slice.call(box.querySelectorAll('p, div, li, span, a'));
      blocks.forEach(function (el) {
        var text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (!text) return;
        if ((text.indexOf('preview:') !== -1 || text === 'preview') && (text.indexOf('elements.meldstudio.co') !== -1 || text.indexOf('http') !== -1 || text === 'preview:' || text === 'preview')) {
          el.setAttribute('hidden', 'hidden');
          var next = el.nextElementSibling;
          if (next && /https?:\/\/|elements\.meldstudio\.co/i.test((next.textContent || '').trim())) {
            next.setAttribute('hidden', 'hidden');
          }
        }
        if (/^https?:\/\/elements\.meldstudio\.co/i.test(text)) {
          el.setAttribute('hidden', 'hidden');
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanPreviewMarkersV3);
  } else {
    cleanPreviewMarkersV3();
  }
})();

// V12: Fit direct Live Widget Preview iframes without mobile drift.
// Desktop keeps the original 1920x1080 browser-source canvas.
// Mobile uses a slightly larger virtual canvas so the widget content looks smaller,
// but it is still centered by JavaScript instead of being offset by CSS.
(function () {
  var DESKTOP_W = 1920;
  var DESKTOP_H = 1080;
  var MOBILE_W = 2400;
  var MOBILE_H = 1350;

  function getSourceSize() {
    return window.matchMedia && window.matchMedia('(max-width: 900px)').matches
      ? { w: MOBILE_W, h: MOBILE_H }
      : { w: DESKTOP_W, h: DESKTOP_H };
  }

  function fitOne(frame) {
    var stage = frame.closest('.lp-widget-preview-stage');
    if (!stage) return;
    var rect = stage.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    var src = getSourceSize();
    var scale = Math.min(rect.width / src.w, rect.height / src.h);
    var left = (rect.width - src.w * scale) / 2;
    var top = (rect.height - src.h * scale) / 2;

    frame.style.setProperty('position', 'absolute', 'important');
    frame.style.setProperty('top', '0', 'important');
    frame.style.setProperty('left', '0', 'important');
    frame.style.setProperty('width', src.w + 'px', 'important');
    frame.style.setProperty('height', src.h + 'px', 'important');
    frame.style.setProperty('min-width', src.w + 'px', 'important');
    frame.style.setProperty('min-height', src.h + 'px', 'important');
    frame.style.setProperty('max-width', 'none', 'important');
    frame.style.setProperty('max-height', 'none', 'important');
    frame.style.setProperty('transform-origin', 'top left', 'important');
    frame.style.setProperty('transform', 'translate(' + left + 'px, ' + top + 'px) scale(' + scale + ')', 'important');
  }

  function fitAll() {
    document.querySelectorAll('.lp-widget-preview-frame').forEach(fitOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fitAll);
  } else {
    fitAll();
  }
  window.addEventListener('resize', fitAll, { passive: true });
  window.addEventListener('orientationchange', function(){ setTimeout(fitAll, 120); }, { passive: true });
  window.addEventListener('load', fitAll);
  window.addEventListener('resize', fitAll, { passive: true });
  setTimeout(fitAll, 250);
  setTimeout(fitAll, 1000);
})();
